// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"127":"89ae87f3","143":"8ce3efb2","941":"3b143661"}[chunkId] + ".js";
};